import { Event, extraType, Information } from "../simulation/types"

export type DecisionState = {
  activeChoiceType: ChoiceType | null
  selectedTreeItem: Information | null
  addConnectionOpenFlag: boolean
  activeChoice: Choice | null
  activeChoiceConnections: Event[]
  treeSearchResults: number[]
  activeSearchQuery: string
}

export type Choice = {
  choiceType: ChoiceType
  item: Information
  time?: number
  connections?: Event[]
}

export type TreeItemNode = {
  contents: Information
  isExpanded: boolean
  isLeafNode: boolean
  synonyms: string[]
  children: TreeItemNode[]
  parent: TreeItemNode | null
}

export type ChooseActionProps = {
  // placeholder
}

export type ActionChoiceProps = {
  id: string
  name: string
  keyName: ChoiceType
  icon: string
  helpText: string
  isSelected: boolean
  onSelectChoice: (choice: ChoiceType) => void
}

export enum ChoiceType {
  decision = "decision",
  plan = "plan",
  cplan = "cplan", // type for created plan
  eplan = "eplan", // type for executed plan
  search = "search",
  add = "add",
}

export type DecisionType = {
  categoryId: number | null
  checked: boolean
  date: string
  decisionId: number
  description: string
  elapsedTime: string
  id: number
  measureReference: string
  mode: string
  planId: number
  reasonIds: number[]
  text: string
  title: string
  type: string
  order?: number
  eventId?: string | number
}

export type DecisionWithExtraType = DecisionType & Partial<extraType>
